import { apiGet, apiPatch } from './client';
import type {
  ISASecurityIdType,
  ISASecurityIdTypeBatchRequest,
} from '../types/ISASecurityIdType';

export function getISASecurityIdTypes(): Promise<ISASecurityIdType[]> {
  return apiGet<ISASecurityIdType[]>('/api/isa-security-id-types');
}

export function saveBatchISASecurityIdTypes(
  added: ISASecurityIdType[],
  modified: ISASecurityIdType[],
  deletedIds: number[],
): Promise<ISASecurityIdType[]> {
  return apiPatch<ISASecurityIdTypeBatchRequest, ISASecurityIdType[]>(
    '/api/isa-security-id-types/batch',
    { added, modified, deleted: deletedIds },
  );
}
